export type LanguageDirection = "ltr" | "rtl";

export type LanguageCode = "en" | "ar";

export type Language = {
	code: LanguageCode;
	label: string;
	dir: LanguageDirection;
};

const LANGUAGES: readonly Language[] = [
	{ code: "en", label: "English", dir: "ltr" },
	{ code: "ar", label: "العربية", dir: "rtl" },
] as const;

const RTL_LANGS: readonly LanguageCode[] = LANGUAGES.filter(
	(l) => l.dir === "rtl",
).map((l) => l.code);

const SUPPORTED_LANGS: readonly LanguageCode[] = LANGUAGES.map((l) => l.code);

const DEFAULT_LANG: LanguageCode = "en";

export { DEFAULT_LANG, LANGUAGES, RTL_LANGS, SUPPORTED_LANGS };
